import { render, staticRenderFns } from "./huikuan.vue?vue&type=template&id=1e2416af&scoped=true"
import script from "./huikuan.vue?vue&type=script&lang=js"
export * from "./huikuan.vue?vue&type=script&lang=js"
import style0 from "./huikuan.vue?vue&type=style&index=0&id=1e2416af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2416af",
  null
  
)

export default component.exports